import { observer } from 'mobx-react-lite'
import { Table, type ITableProps, type IRowDefault, TableSearch } from 'shared/ui/TableNew'
import { EmptyState, type IDefaultEmptyStateProps } from 'shared/ui'
import styles from './styles.module.scss'

export type IMembersTableProps<T extends IRowDefault> = {
  setSearch: (search: string) => void
  search: string
  tableProps: ITableProps<T>
  emptyStateProps?: Partial<IDefaultEmptyStateProps>
}

export const MembersTable = observer(
  <T extends IRowDefault>({
    setSearch,
    search,
    tableProps,
    emptyStateProps,
  }: IMembersTableProps<T>) => {
    return (
      <div className={styles.container}>
        {!search && !tableProps.loading && !tableProps.rows?.length ? (
          <EmptyState variant='default' text='No members found' {...emptyStateProps} />
        ) : (
          <>
            <TableSearch value={search} onChange={setSearch} />
            <div className={styles.table}>
              <Table virtualization={{ estimateRowHeight: 56 }} {...tableProps} />
            </div>
          </>
        )}
      </div>
    )
  }
)
